export function RightArrowIcon() {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7713_1326)">
        <path
          d="M0.241821 5.99994C0.241821 6.19886 0.320839 6.38962 0.461492 6.53027C0.602144 6.67093 0.792909 6.74994 0.991821 6.74994H10.1793L6.95932 9.96932C6.81842 10.1102 6.73927 10.3013 6.73927 10.5006C6.73927 10.6998 6.81842 10.8909 6.95932 11.0318C7.10022 11.1727 7.29131 11.2519 7.49057 11.2519C7.68983 11.2519 7.88092 11.1727 8.02182 11.0318L12.5218 6.53182C12.5918 6.46214 12.6472 6.37935 12.6851 6.28818C12.7229 6.19702 12.7424 6.09928 12.7424 6.00057C12.7424 5.90186 12.7229 5.80412 12.6851 5.71295C12.6472 5.62179 12.5918 5.539 12.5218 5.46932L8.02182 0.969318C7.95206 0.899554 7.86923 0.844213 7.77808 0.806457C7.68693 0.7687 7.58923 0.749268 7.49057 0.749268C7.39191 0.749268 7.29421 0.7687 7.20306 0.806457C7.11191 0.844213 7.02909 0.899554 6.95932 0.969318C6.88956 1.03908 6.83422 1.12191 6.79646 1.21306C6.7587 1.30421 6.73927 1.40191 6.73927 1.50057C6.73927 1.59923 6.7587 1.69693 6.79646 1.78808C6.83422 1.87923 6.88956 1.96205 6.95932 2.03182L10.1793 5.24994H0.991821C0.792909 5.24994 0.602144 5.32896 0.461492 5.46961C0.320839 5.61027 0.241821 5.80103 0.241821 5.99994Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_7713_1326">
          <rect width="13" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
